/* ==========================================================================
   ProductCardHe > Constants
   ========================================================================== */

const ICO_TTOO = 'suitcase';
const ICO_FLIGHT_HOTEL = 'plane-hotel';
const ICO_FERRY_HOTEL = 'ferry-hotel';
const ICO_TRAIN_HOTEL = 'train-hotel';
const ICO_BUS_HOTEL = 'bus-hotel';
const ICO_LEI = 'hot-air-balloon';
const ICO_SKI = 'snow';
const ICO_DIS = 'disney';
const ICO_GV_CIR = 'earth-arrow';
const ICO_GV_COMB = 'map-markers';
const ICO_GV_RUT = 'car-routes';
const ICO_GV_TER = 'marker-compass';
const ICO_FLIGHT = 'flight';
const ICO_BUS = 'bus';
const ICO_PLANE = 'plane';
const ICO_TRAIN = 'train';
const ICO_FERRY = 'ferry';
const ICO_HOTEL = 'hotel';
const ICO_START = 'star-filled';
const ICO_KEY = 'key';
const ICO_SAFE = 'check-shield';
const ICO_REVIEW = 'thumbs-up-filled';
const ICO_MAGNIFIER = 'magnifier';

const FLI_HOT = 'FLIGHTHOTEL';
const TRA_HOT = 'TRAINHOTEL';
const FER_HOT = 'FERRYHOTEL';

/* Exports */
module.exports = {
    ICONS: {
        ICO_TTOO,
        ICO_FLIGHT_HOTEL,
        ICO_FERRY_HOTEL,
        ICO_TRAIN_HOTEL,
        ICO_BUS_HOTEL,
        ICO_LEI,
        ICO_SKI,
        ICO_DIS,
        ICO_GV_CIR,
        ICO_GV_COMB,
        ICO_GV_RUT,
        ICO_GV_TER,
        ICO_FLIGHT,
        ICO_BUS,
        ICO_TRAIN,
        ICO_FERRY,
        ICO_HOTEL,
        ICO_START,
        ICO_KEY,
        ICO_SAFE,
        ICO_REVIEW,
        ICO_MAGNIFIER,
        ICO_PLANE
    },
    TYPES: {
        FLI_HOT,
        TRA_HOT,
        FER_HOT
    },
    RESIZE: {
        HEADER: {
            resize: {
                width: 400,
                height: 205
            },
            alternative: '/comun/images/not-available.png'
        },
        COMPANY: {
            resize: {
                operation: 'resize',
                suboperation: '',
                width: 100,
                height: 60
            },
            alternative: '/comun/images/not-available.png'
        },
        COMPANY_MODAL: {
            resize: {
                operation: 'resize',
                suboperation: '',
                width: 80,
                height: 30
            },
            alternative: '/comun/images/not-available.png'
        },

        MODAL: {
            resize: {
                operation: 'resize',
                suboperation: 'crop',
                width: 400,
                height: 200
            },
            alternative: '/comun/images/not-available.png'
        }
    },
    TOOLTIP: {
        negative: true,
        placement: 'bottom'
    }
};
